var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-1"},[(_vm.matter_id)?[_c('OldMatterProgram',{attrs:{"matter_id":_vm.matter_id,"allows_crud":_vm.allows_crud,"can_update":_vm.can_update,"can_delete":_vm.can_delete}})]:[_vm._v(" "+_vm._s(_vm.$t("reusable.common.errorOccurred"))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }